export default {
  routes: [
    {
      name: 'tests',
      path: '/directory/tests',
      component: () => import('./views/TheTests.vue'),

    },

    {
      name: 'test',
      path: '/directory/tests/:uuid',
      component: () => import('./views/TheTest.vue'),
    },
  ]
}
